import React, { useRef, useState } from 'react';
import handleEmailFlow from "../EmailSender";

function TrialContact() {
  const form = useRef();
  const [submitStatus, setSubmitStatus] = useState({
    submitted: false,
    success: false,
    error: false
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Starting submission");

    const formData = new FormData(form.current);
    const from_name =
      formData.get("first_name") + " " + formData.get("last_name");
    // const phone = formData.get("phone");
    // const child_name = formData.get("child_name");

    // Base template parameters
    const templateParams = {
      from_name,
      first_name: formData.get("first_name"),
      last_name: formData.get("last_name"),
      email: formData.get("email"),
      phone: formData.get("phone"),
      child_name: formData.get("child_name")
    };

    try {
      setSubmitStatus({ submitted: true, success: false, error: false }); // Initial submission
      await handleEmailFlow(templateParams, "Trial");
      setSubmitStatus({ submitted: true, success: true, error: false }); // Success
      // Reset form after successful submission
      form.current.reset();

      // Reset message after 5 seconds
      setTimeout(() => {
        setSubmitStatus({ submitted: false, success: false, error: false });
      }, 5000);
    } catch (error) {
      console.log("FAILED...", error.text);
      setSubmitStatus({ submitted: true, success: false, error: true }); // Error state
    }
  };

  return (
    <div>
      <form 
        ref={form} 
        onSubmit={handleSubmit} 
        className="flex flex-col w-full mx-auto md:text-lg md:leading-normal"
      >
        <div className="flex flex-col md:flex-row justify-between w-full mb-0">
          <div className="flex-1 md:mr-5">
            <label htmlFor="vorname" className="block mb-1.5 md:mb-0.5">Vorname*</label>
            <input
              type="text"
              name="first_name"
              id="vorname"
              placeholder="Vorname"
              className="block w-full border border-[#676666] rounded-md mb-8 p-2 focus:outline-none focus:border-[3px] focus:border-[#fab535]"
              required
            />
          </div>
          <div className="flex-1">
            <label htmlFor="nachname" className="block mb-1.5 md:mb-0.5">Nachname*</label>
            <input
              type="text"
              name="last_name"
              id="nachname"
              placeholder="Nachname"
              className="block w-full border border-[#676666] rounded-md mb-8 p-2 focus:outline-none focus:border-[3px] focus:border-[#fab535]"
              required
            />
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-between w-full mb-0">
          <div className="flex-1 md:mr-5">
            <label htmlFor="email" className="block mb-1.5 md:mb-0.5">Email*</label>
            <input
              type="email"
              name="email"
              id="email"
              placeholder="Email"
              className="block w-full border border-[#676666] rounded-md mb-8 p-2 focus:outline-none focus:border-[3px] focus:border-[#fab535]"
              required
            />
          </div>
          <div className="flex-1 md:mr-5">
            <label htmlFor="phone" className="block mb-1.5 md:mb-0.5">Telefon*</label>
            <input
              type="tel"
              name="phone"
              id="phone"
              placeholder="Telefon"
              className="block w-full border border-[#676666] rounded-md mb-8 p-2 focus:outline-none focus:border-[3px] focus:border-[#fab535]"
              required
            />
          </div>
          <div className="flex-1">
            <label htmlFor="phone" className="block mb-1.5 md:mb-0.5">Name deines Kindes*</label>
            <input
              type="text"
              name="child_name"
              id="child_name"
              placeholder="Name"
              className="block w-full border border-[#676666] rounded-md mb-8 p-2 focus:outline-none focus:border-[3px] focus:border-[#fab535]"
              required
            />
          </div>
        </div>
        
        <div className="flex flex-row mb-1.5 text-sm">
          <input type='checkbox' id='datenschutz' required className="mr-1.5 mt-0.5" />
          <label htmlFor='datenschutz' className="flex-1 text-[#2f4858] mx-1.5 mb-0.5">
            <a href='/Datenschutz' target="_blank" rel="noreferrer noopener"> Datenschutzbestimmungen</a> zustimmen
          </label>
        </div>

        <div className="relative mx-auto">
          <button
            className="my-2.5 bg-custom_primary text-white text-xl border-0 rounded-full py-2.5 px-5 cursor-pointer self-start hover:text-black disabled:bg-[#cbcbcb] disabled:cursor-not-allowed disabled:hover:text-white"
            type="submit"
            disabled={submitStatus.submitted}
          >
            Absenden
          </button>

          {submitStatus.submitted && (submitStatus.success || submitStatus.error) && (
            <div
              className={`
                absolute -top-12 left-0 p-3 rounded-lg text-sm font-medium
                transition-all duration-300
                ${submitStatus.success
                  ? 'bg-green-100 text-green-800 border border-green-400'
                  : 'bg-red-100 text-red-800 border border-red-400'
                }
              `}
            >
              {submitStatus.success
                ? "Anmeldung erfolgreich gesendet!"
                : submitStatus.error
                  ? "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut."
                  : null
              }
            </div>
          )}
        </div>
      </form>
    </div>
  );
}

export default TrialContact;